module.exports = "<div class=\"aside addCard\" id=\"addCard\" content>\n    <ui-view sidebar=\"sidebar\"></ui-view>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./pages/xo-sidebar-update-card/template.html
// module id = ./pages/xo-sidebar-update-card/template.html
// module chunks = 1